/* Paleta de séries derivada dos tokens shadcn (sem hex hardcoded — ADR-0118/0359).
   Cada cor é uma CSS var resolvida em runtime, então respeita o tema claro/escuro. */
const CHART_COLORS: readonly string[] = [
  'var(--primary)',
  'var(--accent)',
  'var(--primary-500)',
  'var(--destructive)',
  'var(--primary-700)',
  'var(--muted-foreground)',
];

export function colorAt(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length] ?? CHART_COLORS[0] ?? 'var(--primary)';
}
